module.exports = __webpack_public_path__ + "static/lawadvisor-services-02-3d42532a48ae9158f474f07cf85511d3.jpg";